import { cn } from '@/utils/utils'

const Loading = ({
  height,
  isContainer,
  size = 'md',
  blur,
}: {
  height?: number
  isContainer?: boolean
  size?: 'sm' | 'md' | 'lg'
  blur?: boolean
}) => {
  const sizeClasses = {
    sm: {
      container: 'py-8 px-4',
    },
    md: {
      container: 'py-12 px-6',
    },
    lg: {
      container: 'py-16 px-8',
    },
  }

  const currentSize = sizeClasses[size]

  return (
    <div
      className={cn(
        blur
          ? 'absolute inset-0 flex items-center justify-center bg-white/50 backdrop-blur-sm rounded-lg'
          : ''
      )}
    >
      <div
        className={cn(
          'flex items-center justify-center h-10',
          isContainer ? currentSize.container : ''
        )}
        style={height ? { height: `${height}px` } : {}}
      >
        <svg
          className="animate-spin h-8 w-8"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <defs>
            <linearGradient
              id="loadingGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#4B4DED" />
              <stop offset="70%" stopColor="#FFFFFF" />
              <stop offset="100%" stopColor="#FFFFFF" />
            </linearGradient>
          </defs>
          <circle
            className="opacity-100"
            cx="12"
            cy="12"
            r="10"
            stroke="url(#loadingGradient)"
            strokeWidth="2"
          />
        </svg>
      </div>
    </div>
  )
}

export { Loading }
